import { Formik } from "formik";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../shared/hook";
import { format } from "date-fns";
import { FaInfoCircle } from "react-icons/fa";
// import {styles} from "./ProfileCard.module.css"
import style from "./ProfileCard.module.css";

function ProfileCard() {
  const { t, i18n } = useTranslation();
  const userData = useAppSelector((state) => state.auth.userData);

  return (
    <Formik
      initialValues={{}}
      onSubmit={() => {}}
      enableReinitialize={true}
      validateOnChange={true}
      validateOnBlur={true}
    >
      {(formik) => (
        <div className="w-full flex flex-col gap-[40px] font-['Inter']">
          <div className="w-full flex flex-col bg-white rounded-3xl p-[30px] gap-[30px] max-w-[1200px]">
            <div className="flex items-center text-base text-gray-600 font-light gap-x-[10px]">
              <img src="assets/contactData.png" className="w-[20px]" />
              <div className="uppercase">Данные пользователя</div>
            </div>
            <div className="flex gap-x-[100px] gap-y-[20px] items-center text-base flex-wrap">
              <div className="text-gray-600 w-[300px] font-semibold">
                Логин
                <p className="font-light">
                  {userData?.login || "-"}
                </p>
              </div>
              
               <div className="text-gray-600 w-[300px] font-semibold">
                Email
                <p className="text-gray-600 font-light">
                  {userData?.email || "-"}
                </p>
              </div>
              <div className="text-gray-600 w-[300px] font-semibold">
                Имя
                <p className="font-light">
                  {userData?.first_name || "-"}
                </p>
              </div>
             
              
              
              <div className="text-gray-600 w-[300px] font-semibold">
                Телефон
                <p className="text-gray-600 font-light">
                  {userData?.phone || "-"}
                </p>
              </div>
              <div className="text-gray-600 w-[300px] font-semibold">
                Фамилия
                <p className="font-light">
                  {userData?.last_name || "-"}
                </p>
              </div>
              <div className="text-gray-600 w-[300px] font-semibold">
                Дата рождения
                <p className="text-gray-600 font-light">
                  {userData?.date_of_birth || "-"}
                </p>
              </div>
              <div className="text-gray-600 w-[300px] font-semibold">
                Отчество
                <p className="font-light">
                  {userData?.second_name || "-"}
                </p>
              </div>
              <div className="text-gray-600 w-[300px] font-semibold">
                Роли
                <div className="text-gray-600 font-light">
                  {userData?.roles && userData.roles.length > 0 ? (
                    userData.roles.map((role: any, index: number) => (
                      <p key={index} className="block">
                        {role.name}
                      </p>
                    ))
                  ) : (
                    <p>-</p>
                  )}
                </div>
              </div>
            </div>
          </div>
          {/* <div className="w-full flex flex-col bg-white rounded-3xl p-[30px] gap-[30px] max-w-[1200px]">
            <div className="flex items-center text-base text-gray-600 font-light gap-x-[10px]">
              <img src="assets/orgData.png" className="w-[20px]" />
              <div className="uppercase">
                {t("profile_card.organization_title")}
              </div>
            </div>
            <div className="flex gap-x-[100px] gap-y-[20px] items-center text-base flex-wrap">
              <div className="text-gray-600 w-[300px] font-semibold">
                {t("profile_card.organization_name")}
                <p className="text-gray-600 font-light">
                  {userData.organizationName}
                </p>
              </div>
              <div className="text-gray-600 w-[300px] font-semibold">
                {t("profile_card.organization_iin_bin")}

                <p className="text-gray-600 font-light">{userData.iinBin}</p>
              </div>
              <div className="text-gray-600 w-[300px] font-semibold">
                {t("profile_card.organization_address")}

                <p className="text-gray-600 font-light">
                  {`${userData.address.city || ""}${userData.address.city ? "," : ""} 
    ${userData.address.street || ""}${userData.address.street ? "," : ""} 
    ${userData.address.house || ""} 
    ${userData.address.building ? userData.address.building : ""}
    ${userData.address.premises ? userData.address.premises : ""}`}
                </p>
              </div>
              <div className="text-gray-600 w-[300px] font-semibold">
                {t("profile_card.organization_website")}

                <p className="font-light">
                  {userData.organizationWebsite
                    ? userData.organizationWebsite
                    : "-"}
                </p>
              </div>
              <div className="text-gray-600 w-[300px] font-semibold">
                {t("profile_card.organization_phone")}

                <p className="font-light">{userData.organizationPhone}</p>
              </div>
              <div className="text-gray-600 w-[300px] font-semibold">
                {t("profile_card.organization_email")}

                <p className="font-light">{userData.organizationEmail}</p>
              </div>
              <div className="text-gray-600 w-[300px] font-semibold">
                {t("profile_card.code_ogd")}
                {userData.address.refOgd?.id &&
                  userData.address.refOgd?.name ? (
                  <p className="font-light">
                    {userData.address.refOgd?.name}
                  </p>
                ) : (
                  <p className="font-light">-</p>
                )}
              </div>
            </div>
          </div> */}

          {/* <div className="w-full flex flex-col bg-white rounded-3xl p-[30px] items-stretch gap-[30px] max-w-[1200px] max-h-[230px]">
            <div className="flex items-center text-base text-gray-600 font-light gap-x-[10px]">
              <img src="assets/docs.png" className="w-[20px]" />
              <div className="uppercase">
                {t("profile_card.participation_in_the_system")}
              </div>
            </div>

            <div className="flex gap-x-[100px] gap-y-[20px]  text-base flex-wrap">
              <div className="flex flex-col gap-[20px]">
                <div className="text-gray-600 w-[300px] font-semibold">
                  <div className={style.tooltipWrapper}>
                    {t('profile_card.registration_date')}
                    <FaInfoCircle className={style.errorIcon} />
                    <div className={style.tooltipText}>
                      {t('profile_card.registration_date_tooltip')}
                    </div>
                  </div>
                  {userData.createdAt ? (
                    <p className="text-gray-600 font-light">
                      {format(new Date(userData?.createdAt), 'dd.MM.yyyy')}
                    </p>
                  ) : (
                    '-'
                  )}

                </div>
                <div className="text-gray-600 w-[300px] font-semibold">
                  {t("profile_card.organization_product_group")}

                  <p className="font-light">
                    {userData.refProductGroup.name
                      ? userData.refProductGroup.name
                      : "-"}
                  </p>
                </div>
              </div>
              <div className="text-gray-600 max-w-[600px] w-full font-semibold max-h-[100px]">
                {t("profile_card.role")}

                <div className="text-gray-600 font-light grid grid-cols-2 gap-4">
                  {userData?.selectRoleV2?.length > 0 ? (
                    userData.selectRoleV2.slice(0, 4).map((role: any, index: any) => (
                      <p key={index} className="block">
                        {role.nameRu}
                      </p>
                    ))
                  ) : (
                    <p>-</p>
                  )}
                </div>
              </div>

            </div>
          </div>

          <div className="w-full flex flex-col bg-white rounded-3xl p-[30px] items-stretch gap-[30px] max-w-[1200px]">
            <div className="flex items-center text-base text-gray-600 font-light gap-x-[10px]">
              <img src="assets/docs.png" className="w-[20px]" />
              <div className="uppercase">{t("profile_card.bank_title")}</div>
            </div>
            <div className="flex gap-x-[100px] gap-y-[20px] items-center text-base flex-wrap">
              <div className="text-gray-600 w-[300px] font-semibold">
                {t("profile_card.bank_name")}
                <p className="text-gray-600 font-light">
                  {userData.refBankCatalog.name
                    ? userData.refBankCatalog.name
                    : "-"}
                </p>
              </div>
              <div className="text-gray-600 w-[300px] font-semibold">
                {t("profile_card.bank_identification_code")}
                <p className="text-gray-600 font-light">
                  {userData.bankIdentificationCode}
                </p>
              </div>
              <div className="text-gray-600 w-[300px] font-semibold">
                {t("profile_card.bank_checking_account")}
                <p className="text-gray-600 font-light">
                  {userData.checkingAccount}
                </p>
              </div>
              <div className="text-gray-600 w-[300px] font-semibold">
                {t("profile_card.bank_kbe")}
                <p className="font-light">
                  {userData.kbe ? userData.kbe : "-"}
                </p>
              </div>
            </div>
          </div>

          <div className="w-full flex flex-col bg-white rounded-3xl p-[30px] gap-[30px] max-w-[1200px]">
            <div className="flex items-center text-base text-gray-600 font-light gap-x-[10px]">
              <img src="assets/docs.png" className="w-[20px]" />
              <div className="uppercase">
                {t("profile_card.documents_title")}
              </div>
            </div>
            <div className="flex flex-wrap items-center w-full gap-x-[30px]">
            </div>
          </div>
          <div className="pb-[2px]"></div> */}
        </div>
      )}
    </Formik>
  );
}

export default ProfileCard;
